import { FormattedMessage } from "react-intl";
export type IPostion = {
  left: number;
  bottom: number;
};

type IPostionBoxProps = {
  pointPostion: IPostion;
};

export const PointBox = ({ pointPostion }: IPostionBoxProps) => {
  return (
    <div className="mt-[30px] relative pl-[36px]">
      <div className="relative w-full">
        <div
          className="absolute z-[10] w-[10px] h-[10px] rounded-full bg-white shadow-[0_1px_5px_rgba(58,58,58,0.28)] flex items-end"
          style={{
            left: pointPostion.left + "px",
            bottom: pointPostion.bottom + "px",
          }}
        ></div>
        <div className="w-[262px] h-[228px] bg-box6-gradient flex items-end">
          <span className="text-[11px] text-black333  dark:text-white dark:opacity-80 opacity-60 pl-[7px] flex items-center leading-3 h-[42px] top-0 absolute">
            <FormattedMessage id="meter.detail.severeHypertension" />
          </span>
          <span className="bottom-[214px] font-medium block w-[25px] -left-[35px] text-right text-primary absolute leading-6 text-sm">
            SYS
          </span>
          <span className="left-[250px] font-medium -bottom-[27px] text-primary absolute leading-6 text-sm">
            DIA
          </span>
          <div className="w-[222px] h-[188px] flex items-end bg-box5-gradient">
            <span className="text-[11px] text-black333 opacity-60 dark:text-white dark:opacity-80 pl-[7px] flex items-center leading-3 h-[36px] top-[42px] max-w-[230px] absolute">
              <FormattedMessage id="meter.detail.moderateHypertension" />
            </span>
            <span className="bottom-[175px] block w-[25px] -left-[35px] text-right text-gray666 dark:text-white80 absolute leading-6 text-sm">
              180
            </span>
            <span className="left-[214px] -bottom-[27px] text-gray666 dark:text-white80 absolute leading-6 text-sm">
              110
            </span>
            {/* bg-box4-gradient */}
            <div className="w-[182px] h-[148px] flex items-end bg-[#FBDA66]">
              <span className="text-[11px] text-black333 opacity-60 dark:text-white dark:opacity-80 pl-[7px] flex items-center leading-3 h-[40px] top-[78px] max-w-[175px] absolute">
                <FormattedMessage id="meter.detail.mildHypertension" />
              </span>
              <span className="bottom-[135px] block w-[25px] -left-[35px] text-right text-gray666 dark:text-white80 absolute leading-6 text-sm">
                160
              </span>
              <span className="left-[170px] -bottom-[27px] text-gray666 dark:text-white80 absolute leading-6 text-sm">
                100
              </span>
              <div className="w-[142px] h-[108px] flex items-end bg-box3-gradient">
                <span className="text-[11px] text-black333 opacity-60 dark:text-white dark:opacity-80 pl-[7px] flex items-center leading-3 h-[20px] top-[120px] max-w-[135px] absolute">
                  <FormattedMessage id="meter.detail.highNormal" />
                </span>
                <span className="bottom-[95px] block w-[25px] -left-[35px] text-right text-gray666 dark:text-white80 absolute leading-6 text-sm">
                  140
                </span>
                <span className="left-[135px] -bottom-[27px] text-gray666 dark:text-white80 absolute leading-6 text-sm">
                  90
                </span>
                <div className="w-[122px] h-[88px] flex items-end bg-box2-gradient">
                  <span className="text-[11px] text-black333 opacity-60 dark:text-white dark:opacity-80 pl-[7px] flex items-center leading-3 h-[20px] top-[140px] max-w-[165px] absolute">
                    <FormattedMessage id="meter.detail.normal" />
                  </span>
                  <span className="bottom-[75px] block w-[25px] -left-[35px] text-right text-gray666 dark:text-white80 absolute leading-6 text-sm">
                    130
                  </span>
                  <span className="left-[115px] -bottom-[27px] text-gray666 dark:text-white80 absolute leading-6 text-sm">
                    85
                  </span>
                  <div className="w-[102px] h-[68px] flex items-end bg-box1-gradient">
                    <span className="text-[11px] text-black333 opacity-60 dark:text-white dark:opacity-80 pl-[7px] flex items-center leading-3 h-[20px] top-[160px] max-w-[95px] absolute">
                      <FormattedMessage id="meter.detail.optimal" />
                    </span>
                    <span className="bottom-[55px] block w-[25px] -left-[35px] text-right text-gray666 dark:text-white80 absolute leading-6 text-sm">
                      120
                    </span>
                    <span className="left-[95px] -bottom-[27px] text-gray666 dark:text-white80 absolute leading-6 text-sm">
                      80
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
